module.exports = __webpack_public_path__ + "img/T2A_xs_02.41cc2dd7.png";